import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown as AntDropdown, Menu as AntMenu } from 'antd-v5';
import styled from 'styled-components';
import { theme } from 'styles';
import { Image, WithTooltip } from 'UI';
import { GLViewer } from './GLViewer';
import { ButtonsContainer, ViewerButton } from './ViewerControls.styled';

type Props = {
  viewer: GLViewer;
};

export const SAntDropdown = styled(AntDropdown)<{ bordered: boolean; mainSearch?: boolean }>`
  width: ${({ mainSearch }) => (mainSearch ? 70 : 80)}px;
  display: flex;
  align-items: center;
  height: 30px;
  border: 1px solid ${theme.color.grey85};
  background-color: ${theme.color.white};
  border-radius: 3px;
`;

export const ViewerControls: React.FC<Props> = ({ viewer }) => {
  const { t } = useTranslation();
  const views = GLViewer.enums.views;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [colorMode, setColorMode] = useState(viewer.current_color); //NOSONAR
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [movementMode, setMovementMode] = useState(viewer.movement_mode); //NOSONAR

  const toggleColor = () => {
    viewer.toggleColor();
    setColorMode(viewer.current_color);
  };

  const nextMovement = () => {
    viewer.nextMovementMode();
    setMovementMode(viewer.movement_mode);
  };

  const viewMenu = (
    <AntMenu>
      {Object.entries(views).map(([name, value]) => (
        <AntMenu.Item key={name} onClick={() => viewer.applyView(value)} id={'buttons_container_item' + value}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }} id={'buttons_container' + value}>
            <Image src={`3d/orientation/${viewer.getImg(value)}.png`} alt={name} width={20} height={20} />
            {name}
          </div>
        </AntMenu.Item>
      ))}
    </AntMenu>
  );

  return (
    <ButtonsContainer id={'buttons_container'}>
      <WithTooltip title={t('catalog.3d_view.color_mode', 'Color')}>
        <ViewerButton onClick={toggleColor}>
          <Image src={`3d/${viewer.getColorImage()}`} alt={'Color'} width={20} height={20} />
        </ViewerButton>
      </WithTooltip>
      <WithTooltip title={t('catalog.3d_view.movement_mode', 'Movement')}>
        <ViewerButton onClick={nextMovement}>
          <Image src={`3d/${viewer.getMovementModeImage()}`} alt={'Movement'} width={20} height={20} />
        </ViewerButton>
      </WithTooltip>

      <SAntDropdown bordered={true} overlay={viewMenu} trigger={['click']}>
        <ViewerButton>{t('catalog.3d_view.view', 'View')}</ViewerButton>
      </SAntDropdown>
    </ButtonsContainer>
  );
};
